import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { StockTrnHDModel } from '../models/StockTrnModel';
import { StockTrnDetModel } from '../models/StockTrnModel';
import { URLsConfig } from '../URLsConfig';
import { InvoicesModel } from '../models/InvoicesModel';

@Injectable()
export class StockTrnService {
    constructor(private http: HttpClient, public urlsconfig: URLsConfig) {
    }
    //// ==================== Header ======================================
    public GetStockTrnHD(hedtype: string, hedserial : string , comCode: string) {
      let params = new HttpParams();
        params = params.append("HedType", hedtype);
        params = params.append("HedSerial", hedserial);
        params = params.append("CompCode", comCode);
        const options = {
            params: params
        };
        return this.http.get<StockTrnHDModel>(this.urlsconfig.WebAPIURL_Test + 'api/StockTrn/GetStockTrnHd',options);
    }
    public AddStockTrnHD(stocktrnhd: StockTrnHDModel) {
        return this.http.post<StockTrnHDModel>(this.urlsconfig.WebAPIURL_Test + 'api/StockTrn/AddStockTrnHd', stocktrnhd);
    }
    public DelStockTrnHD(hedtype: string, hedserial : string , comCode: string) {
      let params = new HttpParams();
      params = params.append("HedType", hedtype);
      params = params.append("HedSerial", hedserial);
      params = params.append("CompCode", comCode);
        const options = {
          params: params
      };
      return this.http.get<StockTrnHDModel>(this.urlsconfig.WebAPIURL_Test + 'api/StockTrn/DeleteStockTrnHd',options);
    }
    public GetStockTrnHDLookup(hedtype: string, hedserial: string, Patientfname: string ,compCode: string) {
      let params = new HttpParams();
      params = params.append("HedType", hedtype);
      params = params.append("HedSerial", hedserial);
      params = params.append("PatientFName", Patientfname);
      params = params.append("CompCode", compCode);
      const options = {
          params: params
      };
      return this.http.get<StockTrnHDModel[]>(this.urlsconfig.WebAPIURL_Test + 'api/StockTrn/StockTrnHdLookup', options);
    }

    public GetStockTrnHdSerial(hedtype:string ,comCode: string) {
      let params = new HttpParams();
      params = params.append("HedType", hedtype);
      params = params.append("compcode", comCode);
      const options = {
        params: params
      };
      return this.http.get<StockTrnHDModel>(this.urlsconfig.WebAPIURL_Test + 'api/StockTrn/GetStockTrnHdSerial', options);
    }

    public StockTrnHDLookupToop(hedtype:string ,comCode: string) {
      let params = new HttpParams();
      params = params.append("HedType", hedtype);
      params = params.append("compcode", comCode);
      const options = {
        params: params
      };
      return this.http.get<StockTrnHDModel[]>(this.urlsconfig.WebAPIURL_Test + 'api/StockTrn/StockTrnHdLookupTop', options);
    }

    //// ==================== Details ======================================
    public GetStockTrnDet(dettype: string, detserial : string , comCode: string) {
      let params = new HttpParams();
        params = params.append("DetType", dettype);
        params = params.append("DetSerial", detserial);
        params = params.append("CompCode", comCode);
        const options = {
            params: params
        };
        return this.http.get<StockTrnDetModel[]>(this.urlsconfig.WebAPIURL_Test + 'api/StockTrn/GetStockTrnDet',options);
    }
    public AddStockTrnDet(stocktrndet: StockTrnDetModel) {
      return this.http.post<StockTrnDetModel>(this.urlsconfig.WebAPIURL_Test + 'api/StockTrn/AddStockTrnDet', stocktrndet);
  }

  public DelStockTrnDet(dettype: string, detserial : string , comCode: string) {
    let params = new HttpParams();
      params = params.append("DetType", dettype);
      params = params.append("DetSerial", detserial);
      params = params.append("CompCode", comCode);
      const options = {
          params: params
      };
      return this.http.get<StockTrnDetModel>(this.urlsconfig.WebAPIURL_Test + 'api/StockTrn/DeleteStockTrnDet',options);
  }
  public DelStockTrnDetLine(dettype: string, detserial : string ,detline : string , comCode: string) {
    let params = new HttpParams();
      params = params.append("DetType", dettype);
      params = params.append("DetSerial", detserial);
      params = params.append("DetLine", detline);
      params = params.append("CompCode", comCode);
      const options = {
          params: params
      };
      return this.http.get<StockTrnDetModel>(this.urlsconfig.WebAPIURL_Test + 'api/StockTrn/DeleteStockTrnDetLine',options);
  }
    public GetInvoicesVisit(w_patient: string, w_date : string) {
      let params = new HttpParams();
        params = params.append("w_patient", w_patient);
        params = params.append("w_date", w_date);

        const options = {
            params: params
        };
        return this.http.get<InvoicesModel>(this.urlsconfig.WebAPIURL_Test + 'api/StockTrn/GetInvoicesVisit',options);
    }

}
